import React, { PropTypes } from 'react';

import Button from '../../../Button';
import ButtonLink from '../../../ButtonLink';
import CharityModal from '../CharityModal';

import {
  arrow,
  button,
  container,
  detail,
  header,
  heading,
  info,
  prevPrice,
  price,
} from './styles.module.css';

/**
 * Ticket list item presentational component.
 */
const TicketListItem = ({
  availableDate,
  availableDateFormatted,
  buttonLabel,
  buttonProps,
  charityDescription,
  charityName,
  discountPriceFormatted,
  expiryDate,
  expiryDateFormatted,
  expiryLabel,
  hasBookingFee,
  isCharityTicket,
  rrpFormatted,
  title,
}) => (
  <article className={container}>
    <header className={header}>
      <h3 className={heading}>{title}</h3>
      <div className={info}>
        {isCharityTicket &&
          (charityName && charityDescription) && (
            <CharityModal title={charityName} content={charityDescription} />
          )}
        {!isCharityTicket && (
          <span>
            {discountPriceFormatted && <del className={prevPrice}>{rrpFormatted}</del>}{' '}
            <span className={price}>{discountPriceFormatted || rrpFormatted}</span>
          </span>
        )}
        {hasBookingFee && <div className={detail}>{'Plus booking fee'}</div>}
        {availableDate && (
          <div className={detail}>
            {'Available '}
            <time dateTime={availableDate}>{availableDateFormatted}</time>
          </div>
        )}
        {expiryDate && (
          <div className={detail}>
            {`${expiryLabel} `}
            <time dateTime={expiryDate}>{expiryDateFormatted}</time>
          </div>
        )}
      </div>
    </header>
    <footer>
      {buttonProps.disabled && (
        <Button className={button} {...buttonProps}>
          {buttonLabel}
        </Button>
      )}
      {!buttonProps.disabled && (
        <ButtonLink className={button} {...buttonProps}>
          {buttonLabel}
          {buttonProps.primary && <span className={arrow} />}
        </ButtonLink>
      )}
    </footer>
  </article>
);

TicketListItem.propTypes = {
  availableDate: PropTypes.string,
  availableDateFormatted: PropTypes.string,
  buttonLabel: PropTypes.string.isRequired,
  buttonProps: PropTypes.shape({
    primary: PropTypes.bool,
    disabled: PropTypes.bool,
    to: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func,
    rel: PropTypes.string,
  }).isRequired,
  charityDescription: PropTypes.string,
  charityName: PropTypes.string,
  discountPriceFormatted: PropTypes.string,
  expiryDate: PropTypes.string,
  expiryDateFormatted: PropTypes.string,
  expiryLabel: PropTypes.string,
  hasBookingFee: PropTypes.bool,
  isCharityTicket: PropTypes.bool,
  rrpFormatted: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

TicketListItem.defaultProps = {
  availableDate: undefined,
  availableDateFormatted: undefined,
  charityDescription: undefined,
  charityName: undefined,
  discountPriceFormatted: undefined,
  expiryDate: undefined,
  expiryDateFormatted: undefined,
  expiryLabel: undefined,
  hasBookingFee: false,
  isCharityTicket: false,
};

export default TicketListItem;



// WEBPACK FOOTER //
// ./app/src/components/EventTicketsPage/components/TicketListItem/component.jsx